import { ref } from "vue";
import store from "@/store";
import { adminAPI } from "@/laravel/config";
import {
  canMakeAuthenticatedRequest,
  handleUnauthorizedResponse,
} from "@/composables/authRequestGuard";

const postItem = async (table, val) => {
  const res = ref(null);
  const err = ref(null);
  const statusCode = ref(null);
  const errorType = ref(null);

  try {
    if (!canMakeAuthenticatedRequest(table)) {
      errorType.value = "auth";
      throw new Error("Unauthorized");
    }

    const requestOptions = {
      method: "POST",
      headers: {
        "Content-Type": "application/json",
      },
      body: JSON.stringify(val),
    };

    // Add Authorization header only if token exists
    if (store.state?.user?.token) {
      requestOptions.headers.Authorization = `Bearer ${store.state.user.token}`;
    }

    const response = await fetch(adminAPI + `/${table}`, requestOptions);
    statusCode.value = response.status;

    const responseText = await response.text();
    let data = null;

    try {
      data = responseText ? JSON.parse(responseText) : null;
    } catch {
      data = null;
    }

    if (response.status === 401) {
      errorType.value = "auth";
      handleUnauthorizedResponse(table);
      throw new Error("Unauthorized");
    }

    if (response.status === 403) {
      errorType.value = "forbidden";
      throw new Error("Forbidden");
    }

    if (response.status === 422) {
      errorType.value = "validation";
      throw new Error(data?.message || data?.error || "Validation error");
    }

    if (response.status >= 500) {
      errorType.value = "server";
      throw new Error(data?.message || data?.error || "Server error");
    }

    if (!response.ok) {
      errorType.value = "http";
      throw new Error(
        `Network response was not OK: ${response.status} ${response.statusText}`,
      );
    }

    res.value = data;
    
  } catch (error) {
    if (!errorType.value) {
      errorType.value = "network";
    }

    err.value = error.message;
  }

  return { res, err, statusCode, errorType };
};

export default postItem;
